import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setTheme } from "@/util/util";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      box: false,
      text: "",
      list: [{
        name: "vip主题",
        value: "theme-vip"
      }, {
        name: "默认主题",
        value: "default"
      }, {
        name: "白色主题",
        value: "theme-white"
      }, {
        name: "黑色主题",
        value: "theme-dark"
      }, {
        name: "炫彩主题",
        value: "theme-star"
      }, {
        name: "智能主题",
        value: "theme-bule"
      }, {
        name: "iview主题",
        value: "theme-iview"
      }, // {
      //   name: "cool主题",
      //   value: "theme-cool"
      // },
      {
        name: "d2主题",
        value: "theme-d2"
      }, // {
      //   name: "hey主题",
      //   value: "theme-hey"
      // },
      {
        name: "lte主题",
        value: "theme-lte"
      }]
    };
  },
  watch: {
    text: function text(val) {
      console.log(val, '---val');
      this.$store.commit("SET_THEME_NAME", val);
      setTheme(val);
    }
  },
  computed: _objectSpread({}, mapGetters(["themeName"])),
  mounted: function mounted() {
    this.text = this.themeName;

    if (!this.text) {
      this.text = "";
    }
  },
  methods: {
    open: function open() {
      this.box = true;
    }
  }
};